import { gql } from '@apollo/client';

export const BUYER_REMOVE_USER_MUTATION = gql`
  mutation UsersPageBuyerRemoveUser($buyerId: ID!, $userId: ID!) {
    buyerRemoveUser(buyerId: $buyerId, userId: $userId) {
      buyer {
        id
      }
      user {
        id
      }
    }
  }
`;
